var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0625 13.3125H6V29.0625H30.0625V13.3125ZM29.1875 28.1875H6.875V14.1875H29.1875V28.1875Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 10.25H33.125V24.25H30.9375V25.125H34V9.375H9.9375V12.4375H10.8125V10.25Z",
    fill: "#00ADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 15.5H23.9375V19.875H27.875V15.5ZM27 19H24.8125V16.375H27V19ZM20 15.5H20.875V26.875H20V15.5ZM8.1875 16.375H18.6875V17.25H8.1875V16.375ZM8.1875 18.5625H17.375V19.4375H8.1875V18.5625ZM8.1875 20.75H17.8125V21.625H8.1875V20.75Z",
    fill: "#00ADEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostCards);
export default __webpack_public_path__ + "static/media/Post-Cards.a7104400e11735586a2762cde13676dd.svg";
export { ForwardRef as ReactComponent };